import { serializeHTML } from 'components/Editor';
import { isUploaded } from 'components/MediaInput';
import { QuestionForm, UPLOAD_MEDIA_FIELD } from 'model';
import { toggleReplyFormOpen as createToggleReplyFormOpenAction } from 'redux/modules/comment';
import { serializeIntent } from 'utils/intent';
import { Props } from './types';

export const handleFormSubmitted = ({
  contentType,
  createComment,
  id,
}: {
  contentType: Props['contentType'];
  createComment: Props['createComment'];
  id: Props['id'];
}) => ({ comment, title, [UPLOAD_MEDIA_FIELD]: media = [] }: QuestionForm) => {
  const [image] = media.filter(isUploaded);
  const mergedComment = `<h1>${title}</h1>${serializeHTML(comment)}`;

  createComment({
    contentType,
    image: image?.file,
    comment: mergedComment,
    objectId: id,
  });
};

export const handleToggleReplyFormOpen = ({
  beginIntent,
  loggedIn,
  toggleReplyFormOpen: dispatchToggleReplyFormOpen,
  url,
}: {
  beginIntent: Props['beginIntent'];
  loggedIn: Props['loggedIn'];
  toggleReplyFormOpen: Props['toggleReplyFormOpen'];
  url: Props['url'];
}) => (id: string) => {
  if (loggedIn) {
    dispatchToggleReplyFormOpen(id);
  } else {
    beginIntent({
      intent: serializeIntent([createToggleReplyFormOpenAction(id)]),
      returnTo: url,
    });
  }
};
